import React, { useState } from "react";
import { projectsData } from "../fakedata/fakedata";
import Project from "./Project";
import './Projects.css'

const Projects = () => {
  const [projects, setProjects] =  useState(projectsData)
  return (
    <div id="projects-id" className="project-container pt-5">
      <div className="container pt-5">
        <h1 className="mb-5 text-center">Projects</h1>
        <div className="row">
       {
           projects.map((project,index) => <Project key={index} project={project} />)
       }
        </div>
      </div>
    </div>
  );
};

export default Projects;
